export const computeWalletConnectMetaData = ({ appName, appDescription, appUrl, appIcon, }) => {
    return {
        name: appName,
        description: appDescription !== null && appDescription !== void 0 ? appDescription : appName,
        url: appUrl !== null && appUrl !== void 0 ? appUrl : (typeof window !== 'undefined' ? window.location.href : ''),
        icons: [...(appIcon ? [appIcon] : [])],
    };
};
